import React from 'react';

export function renderHTML(string) {
  return <span dangerouslySetInnerHTML={{ __html: this.interpolateParams(string) }} />;
};

export function getURLParams() {
  const url_string = window.location.href;
  const url = new URL(url_string);
  return url.search;
}

export function getURLParam(param) {
    const url = window.location.href;
    const name = param.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

// export function getURLParam(param) {
// 	return new URL( window.location.href ).searchParams.get(param);
// };

export function interpolateParams(string, params=this.state.lpVariables) {
	let newString = string;
	const matches = newString && newString.match(new RegExp(`{{([^}]+)}}`, 'g'));
	if (matches) {
		matches.forEach((param) => {
      const stringParam = param.slice(2,-2);
      if(stringParam.substring(0,5) === 'eval(') {
        // const form = {...this.state.formFields};
        // const vars = {...params};
        newString = newString.replace(param, eval(stringParam.slice(5,-1)) || '');
      } else {
        newString = newString.replace(param, params[param.slice(2,-2)] || '');
      }
		});
	}
	return newString;
};